<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="far fa-star"></i> Riviews </b>
    </div>
    <div class="card-header--actions">
      <!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">-->
      <!--                <span class="btn-wrapper&#45;&#45;icon">-->
      <!--                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
      <!--                </span>-->
      <!--        <span class="btn-wrapper&#45;&#45;label">-->
      <!--                    New User-->
      <!--                </span>-->
      <!--      </button>-->
    </div>
  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <div class="search-wrapper">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </span>
      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">
    </div>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">CLIENT</th>
        <th class="bg-white text-center">REVIEW</th>
        <th class="bg-white text-center">MODIFIED AT</th>
        <th class="bg-white text-center">VIEW MORE</th>
        <th class="bg-white text-center">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of reviwes">
        <td class="font-weight-bold text-center">
          {{pac.clientName}}
        </td>
        <td class="text-center">
          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">
             {{(pac.review | slice:0:40)+ '...'}}
          </span>
        </td>
        <td class="font-weight-bold text-center">
          {{pac.updatedAt}}
        </td>
        <td class="font-weight-bold text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <button  type="button" class="btn btn-warning" (click)="viewMore(pac)">
              <i class="fas fa-eye"></i>
            </button>
          </div>
        </td>

        <td class="text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-success" (click)="approve(pac.id)" ><i class="fas fa-check-circle"></i></button>
            <button type="button" class="btn btn-danger" (click)="reject(pac.id)"><i class="far fa-trash-alt"></i></button>

          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div *ngIf="view!=null" class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Client review</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <h4>Review</h4>
          <p>{{view.review}}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <!--        <button type="button" class="btn btn-primary ml-auto" (click)="addModal.hide()">Save changes</button>-->
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
